import React from 'react';
import { Toast } from 'primereact/toast';

const AIEduToast = React.forwardRef((props, ref) => {
    return <Toast ref={ref} position='top-right' />;
});

export default AIEduToast;
